
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return require("private-next-pages/resources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources"])
      });
    }
  